import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classes from "./AuthCallbackForm.module.css";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthHooks";
import { useCrypto } from "../../../hooks/CryptoHooks";
import { jwtDecode } from "jwt-decode";

const AuthCallbackForm = () => {
    const auth = useAuth();
    const crypto = useCrypto();
    const navigate = useNavigate();
    const { contain, field } = classes;

    const notifyError = (msg) => {
        toast.warn(msg, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("id_token");
        const error = params.get("error");
        if (token) {
            const decoded = jwtDecode(token)
            const exp = decoded.exp * 1000;
            localStorage.setItem("time_expiration", exp);
            auth
                .confirmSignIn()
                .then(() => {
                    // Inicializar encriptación ECDH después de confirmar el login
                    crypto.initEncryption(token);
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => { });

            navigate("/");
        } else {
            if (error) {
                notifyError(error)
            }
            navigate("/login");
        }
    }, [navigate, auth, crypto]);

    return (
        <div className={contain}>
            <form>
                <div className={field}>
                </div>
            </form>
        </div>
    );
};

export default AuthCallbackForm;